(ns common.schema.entities.tenant-inbox
  (:require [common.schema.schema-utils :as su]))

(def schema
  [[:tenant.inbox/email {:field/data-type             :data.type/text
                         :field/default-authorization {:access/read  :role/guest-buy-side
                                                       :access/write :role/system}
                         :field/system-semantics      su/system-controlled-optional-field-semantics}]])
